// src/config.js
const config = {
googleMapsApiKey: "AIzaSyDPZzlCt8aCH-wLB8DUwJwuW4QIVz4Ywqg",
};

export default config;
